export default __webpack_public_path__ + "static/media/bg_triangle.5e443e91.png";